import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const IlertShape = {
  postback_url: Yup.string().label("Postback URL").url().required(),
};

export interface IlertInput {
  postback_url: string;
}

yupResolver<IlertInput>(Yup.object().shape(IlertShape));
